// src/utils/validarCierreEvidencia.js
//
// Validador puro de cierre de informe por evidencias.
// Recibe el conteo (de contarEvidencias) y la clave de módulo; devuelve
// { ok, mensaje }. mensaje es el texto listo para Swal cuando ok === false.
//
// Este incremento (VC) solo enforcea MÍNIMOS. Los máximos no se validan
// (maxFotos:null). El camino de combinaciones disyuntivas (amarre con video:
// "2 fotos+1 video O 3 fotos") queda contemplado pero inactivo hoy, porque
// todas las reglas tienen combinaciones:null.

import { EVIDENCIA_RULES } from '../config/evidenciaRules';

function pluralFotos(n) {
  return n === 1 ? '1 foto' : `${n} fotos`;
}

// Evalúa el camino de combinaciones disyuntivas. Devuelve true si el conteo
// satisface AL MENOS UNA combinación. Contempla video a futuro.
function cumpleAlgunaCombinacion(combinaciones, fotos, videos) {
  return combinaciones.some(
    (c) => fotos >= (c.fotos ?? 0) && videos >= (c.videos ?? 0)
  );
}

export function validarCierreEvidencia(modulo, conteo) {
  const reglas = EVIDENCIA_RULES[modulo];
  const fotos = (conteo && conteo.fotos) || 0;
  const videos = (conteo && conteo.videos) || 0;

  // Si el módulo no tiene reglas definidas, no bloquear (fail-open explícito).
  if (!reglas) {
    return { ok: true, mensaje: '' };
  }

  // Camino futuro: combinaciones disyuntivas (inactivo hoy, todas null).
  if (Array.isArray(reglas.combinaciones) && reglas.combinaciones.length > 0) {
    const ok = cumpleAlgunaCombinacion(reglas.combinaciones, fotos, videos);
    return ok
      ? { ok: true, mensaje: '' }
      : {
          ok: false,
          mensaje:
            'No se cumplen los requisitos de evidencia para cerrar el informe.',
        };
  }

  // Camino actual: mínimos simples.
  const minFotos = reglas.minFotos || 0;
  if (fotos < minFotos) {
    const faltan = minFotos - fotos;
    return {
      ok: false,
      mensaje: `Falta ${pluralFotos(faltan)} para cerrar el informe (mínimo ${minFotos}).`,
    };
  }

  // minVideos queda contemplado; hoy es 0 en todos los módulos.
  const minVideos = reglas.minVideos || 0;
  if (videos < minVideos) {
    const faltan = minVideos - videos;
    return {
      ok: false,
      mensaje: `Falta ${faltan} video${faltan === 1 ? '' : 's'} para cerrar el informe (mínimo ${minVideos}).`,
    };
  }

  return { ok: true, mensaje: '' };
}
